export default __webpack_public_path__ + "0009bf93eb30684b7380a4ea8d72881f.svg";